module.exports = __webpack_public_path__ + "static/media/logo_auth.5163fe8f.png";